<template>
  <div>
    <v-data-table :headers="headers" :items="items" class="elevation-1" dark>
      <template v-slot:item.image="{ value }">
        <v-img class="ma-auto my-2" :src="value" width="200px" aspect-ratio="1.5"></v-img>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>

      <template v-slot:item.content="{ value }">
        <v-dialog max-width="75%" dark>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">預覽</v-btn>
          </template>

          <v-card>
            <v-card-title class="headline" primary-title>
              預覽
            </v-card-title>

            <v-card-text>
              <v-sheet class="secondary pa-12 black--text" style="border-radius: 40px;">
                <v-container>
                  <div v-html="value"></div>
                </v-container>
              </v-sheet>
            </v-card-text>

            <v-divider></v-divider>
          </v-card>
        </v-dialog>
      </template>

      <template v-slot:top>
        <v-toolbar flat dark>
          <v-toolbar-title>會議記錄列表</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.stop="dialog = true" large>新增</v-btn>
        </v-toolbar>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="900px" dark>
      <v-card>
        <v-card-title>
          <span class="headline"></span>
        </v-card-title>

        <v-card-text class="black--text">
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="editedItem.title" label="標題"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="editedItem.date" label="時間"></v-text-field>
            </v-col>
            <v-col cols="12">
              <ckeditor :editor="editor" v-model="editedItem.content" :config="editorConfig"></ckeditor>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "MeetingRecord",
  data() {
    return {
      dialog: false,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          shouldNotGroupWhenFull: true
        }
      },
      headers: [
        { text: "標題", value: "title" },
        { text: "時間", value: "date" },
        { text: "內容", value: "content", align: "center" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      items: [
        {
          title: "第八屆第一次理監事會議紀錄",
          date: "2019-10-15",
          content:
            '<div class="章程法令規章-學會章程內容"><div class="章程法令規章-學會章程內容__a2188fc3e9ea4b7d93eda3732877116e"> 一、 總則 <br><br>( 民國九十四年九月十一日第一屆第一次會員大會通過 ) <br><br>第 一 條、本會名稱為「台灣血管外科學會」，正式英文名稱為「Taiwan Society for Vascular Surgery」，英文簡稱TSVS（以下簡稱本會）。 <br>第 二 條、本會為依法設立、非以營利為目的之社會團體。以聯絡國內外人士共同發揚血管外科醫學之研究、教學、及應用，增進全民健康及國際學術交流為宗旨。 <br>第 三 條、本會以全國行政區域為組織區域。 <br>第 四 條、本會會址設於主管機關所在地區，並得報經主管機關核准設辦事處與分支機構。前項分支機構組織簡則，由理事會擬訂，報請主管機關核准後行之。會址及分支機構之地止於設置及變更時，應報請主管機關核備。 <br>第 五 條、本會之任務如下： <br>一、 促進、鼓勵及改善所有血管疾病健康知識的傳遞，並教育所有大眾血管疾病的保健及照顧。 <br>二、 提供血管外科醫師對於新的手術技術以及知識的教育。 <br>三、 做為所有會員在血管外科所有領域，包括血管內手術的支持組織。 <br>四、 促進改善血管疾病病人的診斷及治療。 <br>五、 清楚的定位出外科手術、血管內手術、以及藥物治療對於血管疾病的治療與預防。 <br>六、 鼓勵血管疾病的臨床及基礎研究。 <br>七、 鼓勵對於血管疾病診斷及治療上新技術的發展及執行，並協助建立血管診察室。 <br>八、 審議有關血管疾病命名及標準，並協助政府與民間制定血管疾病之政策及方案。 <br>九、 規範血管外科有關的社會倫理及法律事項。 <br>十、 提供對血管外科有興趣的外科醫師專門的訓練。 <br>十一、舉辦學術演講及討論。 <br>十二、編輯會訊及有關書刊。 <br>十三、甄審血管外科醫師、血管外科專科指導醫師,以及評鑑培訓血管外科醫師教學醫院，並有頒發證書之資格。 <br>十四、獎助血管外科人才及舉辦其他有關事宜。 <br>十五、其他章程所訂宗旨及任務相關事項。 <br>第 六 條、本會之主管機關為內政部。相關目的的事業主管機關依章程所訂宗旨、任務為行政院衛生署及教育部。目的事業應受各該事業主管機關之指導、監督。 <br><br><br>二、 會員 <br><br>第 七 條、本會會員分下列四種： <br>一、一般會員：對血管外科有興趣者，經本會理事會通過並繳納會費者，得為本會一般會員。 <br>二、專科醫師會員：凡在國內、外醫學院系以上畢業，具外科專科醫師資格，依本會甄審原則甄審合格後，經本會理事會通過並繳納會費者，得為本會專科醫師會員。 <br>三、贊助會員：凡對本會在經濟或其他方面有實際贊助者，經本會理事會通過者，得聘請為二年期贊助會員。 <br>四、榮譽會員：凡對本會有特殊貢獻，經本會理事會通過者，得聘請為榮譽會員。 <br>第 八 條、專科醫師會員﹝會員代表﹞有表決權、選舉權、被選舉權與罷免權。每一會員為一權。但是「一般會員」、「贊助會員」以及「榮譽會員」無表決權、選舉權、被選舉權與罷免權。 <br>第 九 條、會員有遵守本會章程、決議及繳納會費之義務。 <br>第 十 條、會員（會員代表）有違反法令、章程或不遵守會員大會決議時，得經理事會決議，予以警告或停權處分，其危害團體情節重大者，得經會員大會決議予以除名。「會員未繳納會費者，不得享有會員權利，連續二年 <br> 未繳納會費者，視為自動退會。會員經出會、退會或停權處分，如欲申請復會或復權時，除有正當理由者外，應繳清前所積欠之會費。」 <br>第十一條、會員有下列事情之一者，為出會： <br>一、 喪失會員資格者。 <br>二、 經會員大會決議除名者。 <br>第十二條、會員得以書面敘明理由向本會聲明退會。 <br><br><br>三、 組織及職權 <br><br>第十三條、本會以會員大會為最高權力機構。會員人數超過三百人以上時得分區比例選出會員代表，再召開會員代表大會，行使會員大會職權。會員代表任期二年。其各名額及選舉辦法由理事會擬訂，報請主管機關核備後行 <br> 之。會員大會閉會期間由理事會代行職權；監事會為監察機構。 <br>第十四條、會員﹝會員代表﹞大會之職權如下： <br>一、 訂定與變更章程。 <br>二、 選舉或罷免理事、監事。 <br>三、 議決入會費、常年會費、事業及會員捐款之數額及方式。 <br>四、 議決年度工作計畫、報告及預算、決算。 <br>五、 議決會員﹝會員代表﹞之除名處分。 <br>六、 議決財產之處分。 <br>七、 議決本會之解散。 <br>八、 議決與會員權利義務有關之其他重大事項。 <br>前項第八款重大事項之範圍由理事會訂之。 <br>第十五條、本會置理事二十一人、監事七人，由會員選舉之，分別成立理事會、監事會。選舉前項理事、監事時，依計票情形得同時選出候補理事五人、候補監事二人，遇理事、監事出缺時，分別依序遞補之。本屆理事會得 <br> 提出下屆理事、監事候選人參考名單。理事、監事得採用通訊選舉；但不得連續辦理。通訊選舉辦法由理事會通過，報主管機關核備後行之。 <br>第十六條、理事會之職權如下： <br>一、 議決會員大會之召開事項。 <br>二、 審定會員﹝會員代表﹞之資格。 </div></div>'
        },
        {
          title: "第八屆第一次會員大會紀錄",
          date: "2019-09-11",
          content:
            '<div class="章程法令規章-規章-專科醫師甄審辦法內容"><div class="章程法令規章-規章-專科醫師甄審辦法內容__40fbfc27b4614f3b885ea493128a180c"> 專科醫師甄審辦法 <br><br>台灣血管外科學會專科醫師甄審辦法 / 民國九十五年一月十四日 / 第一屆第二次理監事會通過 <br><br>第一章 總則 <br>第一條 <br>台灣血管外科學會（以下簡稱本會）為符合各國醫學教育進步之趨勢，特制訂血管外科專科醫師甄審原則，其目的為培養優秀血管外科醫師及發展國內有關血管外科醫療之學識、技術、設備及研究，使能對國民之健康有更大之貢獻。 <br>第二條 <br>本會為一依法設立之民間學術團體，其認定之合格血管外科專科醫師，僅限於其對血管外科學識、技術及經驗。對政府所頒佈之有關醫師資格及醫師開業之各項法規，並不抵觸。 <br>第二章 血管外科專科醫師甄審委員會 <br>第三條 <br>血管外科專科醫師甄審委員會（以下簡稱本委員會），依台灣血管外科學會組織章程組成。 <br>第四條 <br>本委員之職責為： <br>審核申請甄試醫師之資歷。 <br>聘請血管外科專家及資深望重之血管外科醫師，組成血管外科專科醫師甄審小組，辦理血管外科專科醫師之各項甄審、命題、及評分。 <br>審核及修改血管外科專科臨床訓練之計劃及課程。 <br>審核擔任血管外科專科臨床訓練之醫學中心及醫院之作業情況及設備。 <br>審核各血管外科專科臨床訓練指導醫師之資歷。 <br>第五條 <br>血管外科專科醫師甄審委員，由本委員會主任委員於下列各機構中，選擇下列之適當人員中聘任之。 <br>台灣血管外科學會理監事若干人。 <br>各醫學院或各大教學醫院資深血管外科醫師若干人。 <br>資深望重之執業血管外科醫師若干人。 <br>第三章 血管外科專科醫師甄審考試應具備之資格 <br>第六條 <br>申請血管外科專科醫師甄試者，須具備下列各款資格： <br>曾在國內外公私立大學之醫學院、獨立之醫學院、或醫學專科學校畢業並有該醫學院之畢業證書。 <br>曾通過考試院之醫師考試，並持有該院之醫師考試合格證書。 <br>持有中央衛生主管機關之醫師證書。 <br>取得外科專科醫師資格者。 <br>參加本會取得一般會員醫師資格一年以上者。 <br>於本會認可之專科醫師訓練機構接受訓練滿二年；或已有國外血管外科專科醫師資格，經理監事會審核通過者，得參加甄審考試。但具備下列全部資格，經甄審委員會審查通過且經理監事會認可者，得免筆試： <br>(1) 領有本會認可之國家血管外科專科醫師證書。 <br>(2) 最近三年仍繼續從事血管外科診療工作。 <br>(3) 目前任職於本會認可之血管外科專科訓練機構。 <br>(4) 具有卓著血管外科醫學研究績效者。 <br>參考本學會繼續教育積分認定辦法，得本會繼續教育積分100分﹝含以上﹞。 <br>免試條款：本學會預定2011年開始實施次專科醫師甄試，惟於次專科醫師甄試實施前具備下列全部資格，經甄審委員會審查通過且經理監事會認可者，得免甄試成為本會專科醫師： <br>(1) 取得外科專科醫師資格者。 <br>(2) 加入本學會成為一般會員滿一年。 <br>(3) 參考本學會繼續教育積分認定辦法，得本會繼續教育積分100分﹝含以上﹞。 <br>(4) 此條款於2011年1月1日自動失效。 <br>第四章 申請血管外科專科醫師甄審之程序 <br>第七條 <br>申請甄試之醫師，須向甄審委員會提出下列各款申請書，推薦書及其他證明文件。 <br>血管外科專科醫師甄審之申請書。 <br>指導該醫師之專科指導醫師兩位之推薦書。 <br>外科之專科醫師證書及兩年血管外科專科臨床訓練期滿之證明書，或國外血管外科專科醫師證書。 <br>第八條 <br>本委員會定期召開會議，審查申請甄試醫師之資歷及其所提出之證明文件。甄審合格者，方能參加考試。 <br>第九條 <br>血管外科專科醫師之考試，分為二部份，第一部份為筆試，第二部份為口試，申請甄試之醫師，須先參加第一部份之筆試，當筆試及格後，始能參加第二部份之口試： <br>一、血管外科專科醫師甄審筆試部份： <br>血管外科專科醫師甄審筆試部份，每年舉行一次，筆試之日期、地點及費用，由理監事會決定後公佈或個別通知之。 <br>筆試採用選擇題，時間為三小時，內容分兩部，前一部份有關血管外科之各種基礎醫學（試題佔三分之一），後一部份由臨床血管外科學出題（試題佔三分之二）。 <br>甄審委員會由當地之醫學中心或教學醫院中之血管外科指導醫師及當地具有專長之著名血管外科醫師中，於考試二個月前選聘五至十人，組成筆試小組，擔任命題及評分，為無給職並於考試後解散之。 <br>筆試小組於評定成績後，公佈標準答案並將成績呈報甄審委員會，由甄審委員會通知各申請甄試醫師及格或不及格，但不公布分數。 <br>筆試及格有效期為兩年。 <br>如筆試不及格，可於下次舉行筆試時申請再試，如連續三次不及格時，則須在職訓練滿壹年並取得證明以後再申請參加筆試。 <br>二、血管外科專科醫師甄審口試部份： <br>血管外科專科醫師甄審口試部份，每年亦舉行一次，口試之日期、地點及費用由理監事會決定後公佈或個別通知之。 <br>口試在指定之醫學中心或教學醫院內舉行，內容包括： <br>（1）血管外科科疾病之診斷及處理。 <br>（2）血管疾病之基礎醫學。 <br>（3）血管疾病之流行病學。 <br>（4）非侵襲性血管檢查、血管攝影等血管影像檢查。 <br>甄審委員會由當地之醫學中心或教學醫院中之血管外科指導醫師及當地具有專長之著名血管外科醫師中，選聘五至十人，組成口試小組，擔任口試及評分，為無給職並於考試後解散之。 <br>口試小組於評定口試成績後，呈報甄審委員會，由甄審委員會通知申請甄試醫師及格或不及格，但不公佈分數。 <br>如口試不及格，可於下次舉行試時申請再試，如連續二次不及格時，則須重新參加筆試，筆試及格後，再由請參加口試。 <br>第十條 <br>當申請甄試醫師於筆試及口試二部份考試及格，由甄審委員會主任委員報請台灣血管外科學會理監事會，發給血管外科專科醫師合格之證書。並公佈其姓名地址。 <br>第五章 申請血管外科專科醫師必備之臨床訓練綱要 <br>第十一條 <br>申請血管外科專科醫師甄試者，須具有一年實習醫師訓練完成後之兩年一般外科住院醫師之臨床訓練。 <br>第十二條 <br>在本會認可之血管外科專科醫師訓練機構，完成兩年血管外科專科訓練。 <br>第十三條 <br>兩年血管外科專科臨床訓練之課程及時間之分配，須依據本會專科醫師訓練內容規定施行。並應事先送請甄審委員會備查。 <br>第十四條 <br>血管外科專科醫師臨床訓練受訓期滿，受訓醫師必需熟悉各種血管疾病之診斷、急救及治療。 <br>第十五條 <br>血管外科專科醫師應遵本會規定，定時接受繼續教育訓練之計畫。 <br>第十六條 <br>專科醫師訓練若無法連續接受二年訓練，最長完成訓練時間需在五年內完成，而分段接受訓練者，期間不得間隔三年。 <br>第六章 血管外科專科醫師證書的頒發、有效期限、與更換執照條件 <br>第十七條 <br>經本會甄審辦法通過成為本會血管外科專科醫師，可得申請本會血管外科專科醫師證書。 <br>第十八條 <br>本會血管外科專科醫師證書有效期限六年，期限屆滿得申請更換執照。 <br>第十九條 <br>申請更換血管外科專科醫師執照之醫師，須持續執行符合本會宗旨之血管外科臨床診療業務，接受本會認可之繼續教育訓練，且於專科醫師有效期限六年內取得本會繼續教育績分達600分以上，且不得有一年之積分為零分。若因故於 <br>換証期限內未能取得需要之積分者，得申請展延，經本委員會同意。展延以一次為限，為期一年。 <br>第七章 擔任血管外科專科醫師臨床訓練機構資格之認定及審核 <br>第二十條 <br>擔任血管外科專科醫師臨床訓練之診療機構，須為評鑑合格之教學醫院並且作業時間達一年(含以上)，並合於下列各款全部條件。 <br>具有非侵襲性血管檢查室設備而實際作業者。 <br>具有完整血管攝影與其他血管影像檢查設備而實際作業者。 <br>具有傳統血管外科手術與血管內手術設備而實際作業者。 <br>申請血管外科專科醫師訓練機構者，其必備條件：(1) 為每年非侵襲性血管檢查200例(含)以上。(2) 每年血管攝影檢查（含MRA、CTA）100例(含)以上。(3) 每年周邊血管外科手術及血管腔內手術150例(含)以上。(4) 主動脈或腔靜脈傳 <br>統手術或血管腔內手術5例﹝含﹞以上。 <br>必備條件准向甄審委員會報准後，與其他訓練機構共同訓練。 <br>第二十一條 <br>擔任血管外科專科臨床訓練之診療機構，至少一人有台灣血管外科學會認定合格之專任血管外科專科訓練指導醫師。整個訓練過程，可不局限於同一機構。 <br>第二十二條 <br>申請擔任血管外科專科臨床訓練之診療機構，向甄審委員會申請，開始接受訓練前，須向本委員會提出下列各款文件： <br>參加血管外科專科臨床訓練之申請書。 <br>該診療機構之組織及設備之說明書。 <br>該診療機構最近一年之血管外科醫務作業報告書。 <br>該診療機構之首長及醫務人員之名冊及學歷與經歷。 <br>第二十三條 <br>擔任血管外科專科臨床訓練診療機構，須先向本委員會，申請擔任此種訓練工作，於認可後，始能接受醫師，參加訓練。 <br>第二十四條 <br>甄審委員會在接到診療機構申請書及附件後，應先指定委員二人以上之調查，根據調查報告，開會討論審核，如認為合格時，經理事會認可，授予該診療機構血管外科專科臨床訓練醫院合格證明書。 <br>第二十五條 <br>本委員會應按期指派委員，實施調查參加血管外科專科臨床訓練之診療機構之作業狀況及訓練狀況，作成報告，向甄審委員會提出。甄審委員會議決定某診療機構須作某種之改進時，得函請該診療機構作該項作業之改進，如一年以 <br>後甄審委員會認為該診療機構未曾作該項業務改進之努力，或該項改進未達到甄審委員會之要求時，甄審委員會得建議本會，取消該診療機構臨床訓練血管外科專科醫師之資格。 <br>第二十六條 <br>血管外科專科臨床訓練機構評鑑辦法： <br>每年一月底前接受申請血管外科專科醫師訓練機構評鑑，實施評鑑每年一次。 <br>經評鑑後，準合格之訓練機構可於每年一月底前提出申請評鑑，每一年可申請再評鑑。 <br>經評鑑後，合格之訓練機構每三年由本會統一複審一次。 <br>評鑑結果經理監事會通過之日期，其專科醫師訓練期限可回溯一年。 <br>每年八月本會發函各訓練機構，根據甄審委員會評鑑所核定之員額限制，請其於八月底前將訓練醫師名單列冊並附各相關之外科專科醫師證書與訓練起迄時間等資料報本會審核後，由本會發予訓練許可證明，爾後被訓練醫師才可參 <br>加血管外科專科醫師報考甄審。 <br>第八章 血管外科專科臨床訓練指導醫師之資格 <br>第二十七條 <br>擔任臨床訓練血管外科專科醫師之指導醫師，須具備下列所有資歷： <br>本規則所規定之血管外科專科指導醫師資格，須取得專科醫師證書滿五年。 <br>在經本會認可之國內外診療機構擔任十年以上之臨床工作。 <br>在醫學院或教學醫院擔任五年以上之臨床教學工作，具有豐富之經驗而被認為有血管外科專長者。 <br>2011年1月1日前具上述三項資格即可提出申請，本委員會審查並經理監事會通過成為血管外科專科醫師之指導醫師。 <br>專科醫師最近五年內曾在SCI登錄有案的血管相關雜誌中，以第一作者或通訊作者發表過〈或被接受〉有關血管疾病或治療的原著或綜合評述。（此條款2011年1月1日生效） <br>第二十八條 <br>擔任臨床訓練血管外科專科醫師之指導醫師，須先向本委員會提出其資歷之證明文件，本委員會每年接受申請二次，於每年一月及七月底前申請，經審查合格，承認其資格後，始能擔任指導工作。 <br>第二十九條 <br>指導醫師須負責下列各款工作： <br>為接受血管外科專科臨床訓練之醫師，計劃二年之訓練課程。 <br>直接指導接受臨床訓練醫師之各項臨床工作。 <br>向甄審委員會報告訓練醫師之臨床訓練進度及成績。 <br>第三十條 <br>臨床訓練血管外科專科醫師之指導醫師應專任為無給職，當指導醫師因故喪失其醫師資格，或喪失其血管外科專科醫師資格，或當本委員會認為其擔任訓練工作，未盡其指導責任時，得建議取消其指導醫師之資格。 <br>第九章 專科醫師資格之喪失 <br>第三十一條 <br>具有專科醫師資格之血管外科醫師，如有行為越規，足以損壞台灣血管外科學會之名譽及聲望時，經台灣血管外科學會理監事會通過，得取消其專科醫師之資格。 <br>第三十二條 <br>具有專科醫師資格之血管外科醫師，觸犯下列任何一項者，經台灣血管外科學會理監事會調查證實，並經理監事會通過後，可取消該醫師之專科醫師資格。 <br>觸犯中華民國之刑法，並經法院三審認定者。 <br>經任何級政府機構判罰其停止在中華民國境內執行醫師業務者。 <br>執行醫師業務時，犯有違背醫德，誇大荒謬之宣傳，欺詐病人及其他不道德之行為者。 <br>第三十三條 <br>凡經台灣血管外科學會理監事會取消專科醫師資格者，應無條件繳回專科醫師證書。 <br>第十章 附則 <br>第三十四條 <br>本規則定於中華民國九十四年訂定，九十五年一月一日起施行。 <br>第三十五條 <br>本規則如有未盡善處，由甄審委員會建議，經台灣血管外科學會理監事會議決後，修改或增訂之，並呈內政部備案後實施。 </div></div>'
        }
      ],
      editedIndex: -1,
      editedItem: {
        title: "",
        date: "",
        content: ""
      },
      defaultItem: {
        title: "",
        date: "",
        content: ""
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("確定刪除這筆資料？") && this.items.splice(index, 1);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
      } else {
        this.items.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>

<style></style>
